import Midnight from './Midnight'
export { useOnDayChange } from './Midnight'
export default Midnight
